// Accent colour per order status, shared by the status cards and the latest-orders list so a
// status always reads the same colour wherever it appears.
export const orderStatusColor = (statusId: number): string => {
	switch (statusId) {
		case 1:
			return "#4F16C2";
		case 2:
			return "#AF7575";
		case 3:
			return "#0CAF13";
		case 4:
			return "#0C9AD7";
		case 5:
			return "#C3B10D";
		case 6:
			return "#0CAF13";
		case 7:
			return "#EC132D";
		case 8:
			return "#909090";
		case 10:
			return "#EC132D";
		case 11:
			return "#CC7700";
		case 14:
			return "#C3B10D";
		case 144:
			return "#0C9AD7";
		case 1410:
			return "#EC132D";
		case 13:
			return "#EC132D";
		default:
			return "#A020F0";
	}
};
